import axios from 'utils/axios'
import { getApi } from 'config'

function c (path = '') {
  return getApi().payment + path
}

export default {
  getPlans: () => axios.get(c('/plan'))
}
